import { Box, TextField } from "@mui/material";
import React from "react";
// formik use for handling managing form state,form validation,form submission
export const BecomeSellerFormStep1 = ({ formik }: any) => {

  return (
    <div>
      <Box>
        <p className="text-xl font-bold text-center pb-9">Contact Detail</p>
        <div className="space-y-9">
          <TextField
            fullWidth
            name="mobile"
            label="Mobile"
            value={formik.values.mobile}
            onChange={formik.handleChange}
            error={formik.touched.mobile && Boolean(formik.errors.mobile)}
            helperText={formik.touched.mobile && formik.errors.mobile}
          />

          <TextField
            fullWidth
            name="gstin"
            label="gstin"
            value={formik.values.gstin}
            onChange={formik.handleChange}
            error={formik.touched.gstin && Boolean(formik.errors.gstin)}
            helperText={formik.touched.gstin && formik.errors.gstin}
          />
        </div>
      </Box>
    </div>
  );
};
